import { render, staticRenderFns } from "./DropdownBoxComponent.vue?vue&type=template&id=1571fa2d&scoped=true&lang=pug"
import script from "./DropdownBoxComponent.vue?vue&type=script&lang=js"
export * from "./DropdownBoxComponent.vue?vue&type=script&lang=js"
import style0 from "./DropdownBoxComponent.vue?vue&type=style&index=0&id=1571fa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571fa2d",
  null
  
)

export default component.exports